import { DocumentSaleGuestDetailStatusEnum } from 'api-hooks/sale/travel-document';
import { UploadFileTypeEnum } from 'api-hooks/upload/upload.model';
import { EnumList } from 'common/constants/enum';
import { Input } from 'components/elements';
import EnumSelectInput from 'legacy-modules/master/select-input/enum';
import {
  CardSection,
  FullContainer,
  HalfContainer,
  SectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props {
  documentIndex: number;
  parentName: string;
  documentStatus: DocumentSaleGuestDetailStatusEnum | null;
}

export default function ApecCardSection(props: Props) {
  const { t } = useTranslation();
  const { documentIndex, parentName, documentStatus } = props;

  return (
    <>
      <CardSection style={{ paddingBottom: 0 }}>
        <FullContainer>
          <SectionContainer>
            <HalfContainer>
              <EnumSelectInput
                enumType={EnumList.DocumentType}
                name={`documentSales.${documentIndex}.documentType`}
                label={t('document:document_type')}
                placeholder={t('document:document_type')}
                disabled
              />
            </HalfContainer>
            <HalfContainer>
              <EnumSelectInput
                enumType={EnumList.DocumentSaleGuestDetailStatus}
                name={`${parentName}.documentStatus`}
                label={t('document:document_status')}
                placeholder={t('document:document_status')}
                clearable={false}
              />
            </HalfContainer>
          </SectionContainer>
          {documentStatus !== DocumentSaleGuestDetailStatusEnum.Rejected && (
            <>
              <SectionContainer>
                <HalfContainer>
                  <Input
                    type="text"
                    name={`${parentName}.type`}
                    label={t('common:type')}
                    placeholder={t('common:type')}
                    disabled
                  />
                </HalfContainer>
                <HalfContainer>
                  <Input
                    type="text"
                    name={`${parentName}.name`}
                    label={t('common:name')}
                    placeholder={t('common:name')}
                  />
                </HalfContainer>
              </SectionContainer>
              <SectionContainer>
                <HalfContainer>
                  <Input
                    type="text"
                    name={`${parentName}.applicationNumber`}
                    label={t('common:application_number')}
                    placeholder={t('common:application_number')}
                  />
                </HalfContainer>
                <HalfContainer>
                  <Input
                    type="email"
                    name={`${parentName}.email`}
                    label={t('common:email')}
                    placeholder={t('common:email')}
                  />
                </HalfContainer>
              </SectionContainer>
              <SectionContainer>
                <HalfContainer>
                  <Input
                    type="text"
                    name={`${parentName}.passportNumber`}
                    label={t('common:passport_number')}
                    placeholder={t('common:passport_number')}
                  />
                </HalfContainer>
                <HalfContainer>
                  <Input
                    type="text"
                    name={`${parentName}.pin`}
                    label={t('common:pin')}
                    placeholder={t('common:pin')}
                  />
                </HalfContainer>
              </SectionContainer>
              <SectionContainer>
                <HalfContainer>
                  <Input
                    type="date-time"
                    name={`${parentName}.expiredAt`}
                    label={t('common:expiry_at')}
                    placeholder={t('common:expiry_at')}
                  />
                </HalfContainer>
                <HalfContainer>
                  <Input
                    type="text"
                    name={`${parentName}.documentNumber`}
                    label={t('common:document_number')}
                    placeholder={t('common:document_number')}
                  />
                </HalfContainer>
              </SectionContainer>
              <HalfContainer>
                <Input
                  type="files"
                  label={t('common:upload_document')}
                  valueKey="image"
                  previewKey="url"
                  name={`${parentName}.files`}
                  fileType={UploadFileTypeEnum.DocumentSaleApecCardGuestDetail}
                  required
                />
              </HalfContainer>
            </>
          )}
        </FullContainer>
      </CardSection>
    </>
  );
}
